import { useEffect, useMemo } from "react";
import { useDataTableContext } from "./context";
import { setPersistenceState } from "./handlers";

export function DataTablePersister() {
	/** Context */
	const { persistenceKey, table } = useDataTableContext();

	/** State */
	const state = table.state;
	const { sorting, columnVisibility, pagination, columnPinning, columnSizing, columnOrder } = state;

	const persistenceKeyRef = useMemo(() => persistenceKey, [persistenceKey]);

	/** Effects */
	useEffect(() => {
		setPersistenceState(`${persistenceKeyRef}-sorting`, sorting);
	}, [persistenceKeyRef, sorting]);

	useEffect(() => {
		setPersistenceState(`${persistenceKeyRef}-visibility`, columnVisibility);
	}, [persistenceKeyRef, columnVisibility]);

	useEffect(() => {
		setPersistenceState(`${persistenceKeyRef}-pagination`, pagination);
	}, [persistenceKeyRef, pagination]);

	useEffect(() => {
		setPersistenceState(`${persistenceKeyRef}-pinning`, columnPinning);
	}, [persistenceKeyRef, columnPinning]);

	useEffect(() => {
		setPersistenceState(`${persistenceKeyRef}-sizing`, columnSizing);
	}, [persistenceKeyRef, columnSizing]);

	useEffect(() => {
		setPersistenceState(`${persistenceKeyRef}-order`, columnOrder);
	}, [persistenceKeyRef, columnOrder]);

	/** Render */
	return null;
}
